export default "__VITE_ASSET__BnkDPkm9__"